// extracted by mini-css-extract-plugin
module.exports = {"firmes":"firmes_firmes__w5uOR","veuremes":"firmes_veuremes__nqXax","infoTitol":"firmes_infoTitol___B3AV"};